import { api } from '@/lib/api';
import type { NotificationSchedule, UpdateNotificationSchedule } from '@hygge/shared';

export const schedulesApi = {
  getAll: () =>
    api.get<NotificationSchedule[]>('/notifications/schedules').then((r) => r.data),

  update: (key: string, body: UpdateNotificationSchedule) =>
    api.put<NotificationSchedule>(`/notifications/schedules/${key}`, body).then((r) => r.data),
};
